import { useState, useEffect, useCallback } from 'react';
// @ts-expect-error Could not find a declaration file for module
import UnsavedChanges from 'customer-data-properties/savebar/UnsavedChanges';
import { getPropertyMutationError } from 'customer-data-properties/errors/getPropertyUpdateError';
import I18n from 'I18n';
// @ts-expect-error Could not find a declaration file for module
import addMutationResultAlert from 'customer-data-sidebar/universal/alertHelpers/addMutationResultAlert';
// @ts-expect-error Could not find a declaration file for module
import { useUpdateCrmObjectPropertiesMutation } from 'customer-data-sidebar/universal/hooks/useUpdateCrmObjectPropertiesMutation';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import useNewPropertiesForm from 'customer-data-properties/form/useNewPropertiesForm';
import { useUpdateHighlySensitivePropertyValues } from 'customer-data-properties/dataSensitivity/useUpdateHighlySensitivePropertyValues';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { isVisibleProperty } from '../../utils/isVisibleProperty';
import { usePropertiesCardContext } from './PropertiesCardContext';
import CrmObjectRecord from 'customer-data-objects/crmObject/CrmObjectRecord';
import PropertiesCardInputs from './PropertiesCardInputs';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import debounce from 'transmute/debounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BLANK_PROPERTY_VALUES = ['', undefined, null];
export const trackPropertiesSave = ({
  draft,
  objectTypeId
}) => {
  const eventProps = {
    objectType: denormalizeTypeId(objectTypeId)
  };
  if (Object.prototype.hasOwnProperty.call(draft, 'dealstage')) {
    eventProps.type = 'Deal Stage';
  }
  const updatesArray = Object.keys(draft);
  CrmLogger.log('saved-properties', Object.assign({
    properties: updatesArray.length ? updatesArray.join(' ') : undefined
  }, eventProps));
};
const getGqlUpdatesFromDraftUpdates = draftUpdates => {
  return Object.entries(draftUpdates).map(([name, value]) => ({
    name,
    value
  }));
};
export const getDraftChangesLabel = (draft, properties) => {
  if (!Object.keys(draft).length) {
    return null;
  }
  const draftChangesCount = Object.keys(draft).reduce((filtered, propertyName) => {
    const property = properties.get(propertyName);
    const propertyValue = property ? property.value : undefined;
    const isDraftValueBlank = BLANK_PROPERTY_VALUES.includes(draft[propertyName]);
    const isPropertyInitialValueBlank = property ? property.dataSensitivity !== 'high' && BLANK_PROPERTY_VALUES.includes(propertyValue) : true;
    const isValueBeingRemoved = isDraftValueBlank && !isPropertyInitialValueBlank;
    const isValueBeingAddedOrChanged = !isDraftValueBlank && draft[propertyName] !== propertyValue;
    if (isValueBeingRemoved || isValueBeingAddedOrChanged) {
      return filtered + 1;
    }
    return filtered;
  }, 0);
  if (draftChangesCount < 1) {
    return null;
  }
  const label = I18n.text('cardProperties.changeDescriptions.GENERIC', {
    count: draftChangesCount
  });
  return label;
};
export const getErrorsLabel = status => {
  if (status.invalid) {
    const invalidProperties = status.errors.get('INVALID_PROPERTIES');
    const missingRequiredProperties = status.errors.get('MISSING_REQUIRED_PROPERTY');
    return I18n.text('cardProperties.errorDescriptions.GENERIC', {
      count: (invalidProperties ? invalidProperties.length : 0) + (missingRequiredProperties ? missingRequiredProperties.length : 0)
    });
  }
  return null;
};
const PropertiesCardContent_legacy = () => {
  const {
    cardId,
    crmObject,
    editableAreas,
    objectId,
    objectTypeId,
    onObjectUpdate,
    onSaveSuccess,
    propertyNames,
    propertySourceInfo,
    SuccessMarker,
    CardContentLoadingComponent
  } = usePropertiesCardContext();
  const [draft, setDraft] = useState({});
  const [seleniumSaveComplete, setSeleniumSaveComplete] = useState(true);
  const [componentDidMount, setComponentDidMount] = useState(false);
  const allPropertiesMap = crmObject.allPropertiesMap;
  const propertiesToRender = propertyNames.filter(name => {
    const property = allPropertiesMap.get(name);
    if (property && isVisibleProperty(property)) {
      return true;
    }
    return false;
  }).map(name => ({
    propertyName: name
  }));
  const getSavedValue = useCallback(propertyName => {
    const property = allPropertiesMap.get(propertyName);
    return property ? property.value : undefined;
  }, [allPropertiesMap]);
  const handleChange = useCallback(changes => {
    setDraft(changes);
  }, []);
  const {
    status,
    inputs,
    reset
  } = useNewPropertiesForm({
    getSavedValue,
    objectId: objectId.toString(),
    objectTypeId,
    onChange: handleChange,
    properties: propertiesToRender,
    values: draft
  });
  const handleClearDraft = useCallback(() => {
    setDraft({});
    reset();
  }, [reset]);
  const handleError = useCallback(({
    userErrorsExpanded
  }) => {
    if (userErrorsExpanded && userErrorsExpanded.length) {
      const {
        message,
        severity
      } = getPropertyMutationError({
        error: userErrorsExpanded[0],
        // @ts-expect-error incorrect objectType argument type?
        objectType: objectTypeId,
        // @ts-expect-error types do not match because we don't fetch full objectTypeDefinition
        objectTypeDefinition: crmObject.objectTypeDefinition,
        // @ts-expect-error types do not match because we do not fetch full property value and definition
        getProperty: propertyName => {
          return allPropertiesMap.get(propertyName);
        }
      });
      addMutationResultAlert({
        message,
        type: severity,
        mutationFailed: true
      });
      return;
    }

    // network error, graphql error, or a userError enum with no custom message
    addMutationResultAlert({
      mutationFailed: true
    });
  }, [objectTypeId, crmObject.objectTypeDefinition, allPropertiesMap]);
  const dispatchUpdateObjectAction = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT);
  const updateHighlySensitivePropertyValues = useUpdateHighlySensitivePropertyValues();
  const handleSuccess = useCallback(() => {
    addMutationResultAlert({
      mutationFailed: false
    });
    if (typeof onSaveSuccess === 'function') {
      onSaveSuccess();
    }
    if (typeof onObjectUpdate === 'function') {
      onObjectUpdate({
        objectTypeId,
        objectId,
        properties: draft
      });
    }
    dispatchUpdateObjectAction({
      objectTypeId,
      objectId: objectId.toString(),
      propertyNames: Object.keys(draft)
    });
    updateHighlySensitivePropertyValues({
      objectTypeId,
      objectId: objectId.toString(),
      values: draft
    });
    if (componentDidMount) {
      /* Todo post-partner day: because the save call is async,
            if it takes 10 seconds to complete, we lose any modifications
            the user has done during those 10sec when this delete call runs.
            Make this transactional
          */
      handleClearDraft();
    }
    trackPropertiesSave({
      draft,
      objectTypeId
    });
  }, [onSaveSuccess, onObjectUpdate, dispatchUpdateObjectAction, objectTypeId, objectId, componentDidMount, draft, handleClearDraft, updateHighlySensitivePropertyValues]);
  const handleCompleted = useCallback(() => {
    if (componentDidMount) {
      setSeleniumSaveComplete(true);
    }
  }, [componentDidMount, setSeleniumSaveComplete]);
  const updatePropertiesMutation = useUpdateCrmObjectPropertiesMutation({
    objectType: objectTypeId,
    objectId,
    propertySourceInfo,
    onError: handleError,
    onSuccess: handleSuccess,
    onCompleted: handleCompleted
  });

  // todo - post-partner day - use import { useIsMounted } from 'crm_ui/hooks/useIsMounted';
  useEffect(() => {
    setComponentDidMount(true);
  }, []);
  const updateProperties = useCallback(draftUpdates => {
    setSeleniumSaveComplete(false);
    updatePropertiesMutation(getGqlUpdatesFromDraftUpdates(draftUpdates));
  }, [updatePropertiesMutation]);
  const subject = CrmObjectRecord.fromJS({
    objectId,
    properties: Object.fromEntries(allPropertiesMap)
  });
  const prepareToSavePropertiesUpdates = useCallback(() => {
    updateProperties(draft);
  }, [updateProperties, draft]);
  const handleSaveDraft = useCallback(event => {
    event.preventDefault();
    if (!status.saveable) {
      return;
    }
    prepareToSavePropertiesUpdates();
  }, [status, prepareToSavePropertiesUpdates]);
  if (!propertiesToRender.length) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardProperties.emptyState"
      }), SuccessMarker && /*#__PURE__*/_jsx(SuccessMarker, {})]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-save-complete": seleniumSaveComplete,
    "data-properties-card-id": cardId,
    "data-selenium-test": "properties-card-content"
    // Used for onboarding tours, #growth-onboarding for more details
    ,
    "data-onboarding": "properties-card-content",
    children: /*#__PURE__*/_jsx(UnsavedChanges, {
      changes: getDraftChangesLabel(draft, allPropertiesMap),
      errors: getErrorsLabel(status),
      loading: status.loading,
      onCancel: handleClearDraft,
      onSave: debounce(200, handleSaveDraft),
      editableAreas: editableAreas,
      children: status.validationStatus !== 'INITIALIZING' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(PropertiesCardInputs, {
          inputs: inputs,
          allProperties: allPropertiesMap,
          subject: subject
        }), SuccessMarker && /*#__PURE__*/_jsx(SuccessMarker, {})]
      }) : /*#__PURE__*/_jsx(CardContentLoadingComponent, {
        cardId: cardId,
        numberOfSkeletons: propertiesToRender.length
      })
    })
  });
};
export default PropertiesCardContent_legacy;